<template>
  <div class="license-research">
    <div class="ui-hearder-bj license-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/license/bj.png')" alt="" srcset="">
      <div class="science-bj-txt ">
        <div class="ui-title textc">{{ $t('license.title') }}</div>
        <div class="ui-des textc">{{ $t('license.des') }}</div>
      </div>
    </div>
    <div class="license-content">
      <div class="license-main-title" :style="results.visible ? 'border-bottom: 0;' : ''">
        <div v-if="!results.visible" class="license-main-title-box">{{ $t('license.form.des') }}</div>
      </div>
      <div v-if="!results.visible" class="license-main-box">
        <div class="license-item">
          <div class="license-item-title p-t-15 p-b-30">{{$t('license.form.title')}}</div>
          <el-form ref="licenseForm" :model="formData" :rules="rules"  label-position="top" class="license-form">
            <el-form-item :label="$t('license.form.topic.label')" prop="topic">
              <el-select v-model="formData.topic" :placeholder="$t('license.form.topic.placeholder')" @change="changeTopic">
                <el-option :label="item.label" :value="item.value" v-for="item in topic" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <div class="el-form-item is-required" :class="{'is-success': required.serialNumber, 'is-error': !required.serialNumber, 'form-show': formData.topic == 'REGISTER', 'form-hide': formData.topic != 'REGISTER'}">
              <label for="serialNumber" class="el-form-item__label">{{$t('license.form.serialNumber.label')}}</label>
              <div v-show="!required.serialNumber" class="el-form-item__error">{{ this.$t('license.form.serialNumber.required')[formData.serialNumber == '' ? 0 : 1] }}</div>
              <div class="el-form-item__content posrel">
                <el-tooltip v-if="$route.query.serial != undefined || $route.query.serial != null" class="item" effect="light" placement="top-start">
                  <div slot="content">{{formData.serialNumber}}</div>
                  <div class="posabs wh100" style="z-index: 2;"></div>
                </el-tooltip>
                <div class="el-input" :class="{'is-disabled': this.$route.query.serial}">
                  <input ref="serialNumber" type="text" autocomplete="off" :placeholder="$t('license.form.serialNumber.placeholder')" class="el-input__inner" :disabled="$route.query.serial != undefined || $route.query.serial != null" pattern="[a-zA-Z0-9\s]*" @input="changeInput($event, 'serialNumber')" @blur="blurSerialNumber"/>
                </div>
              </div>
            </div>
            <div ref="institution" class="el-form-item is-required" :class="required.institution ? 'is-success' : 'is-error'">
              <label for="institution" class="el-form-item__label">{{$t('license.form.institution.label')}}</label>
              <div v-show="!required.institution" class="el-form-item__error">{{ this.$t('license.form.institution.required')[0] }}</div>
              <div class="el-form-item__content">
                <div class="el-input">
                  <input type="text" autocomplete="off" maxlength="100" :placeholder="$t('license.form.institution.placeholder')" class="el-input__inner" @input="changeInput($event, 'institution')" @blur="validInput('institution')"/>
                </div>
              </div>
            </div>
            <div ref="profession" class="el-form-item is-required" :class="required.profession ? 'is-success' : 'is-error'">
              <label for="profession" class="el-form-item__label">{{$t('license.form.profession.label')}}</label>
              <div v-show="!required.profession" class="el-form-item__error">{{ this.$t('license.form.profession.required')[0] }}</div>
              <div class="el-form-item__content">
                <el-select v-model="formData.profession" :placeholder="$t('license.form.profession.placeholder')" @change="handleChange('profession')">
                  <el-option :label="item.label" :value="item.value" v-for="item in profession" :key="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div ref="surname" class="el-form-item is-required" :class="required.surname ? 'is-success' : 'is-error'">
              <label for="surname" class="el-form-item__label">{{$t('license.form.surname.label')}}</label>
              <div v-show="!required.surname" class="el-form-item__error">{{ this.$t('license.form.surname.required')[0] }}</div>
              <div class="el-form-item__content">
                <div class="el-input">
                  <input type="text" autocomplete="off" maxlength="40" :placeholder="$t('license.form.surname.placeholder')" class="el-input__inner" @input="changeInput($event, 'surname')" @blur="validInput('surname')"/>
                </div>
              </div>
            </div>
            <div ref="name" class="el-form-item is-required" :class="required.name ? 'is-success' : 'is-error'">
              <label for="name" class="el-form-item__label">{{$t('license.form.name.label')}}</label>
              <div v-show="!required.name" class="el-form-item__error">{{ this.$t('license.form.name.required')[0] }}</div>
              <div class="el-form-item__content">
                <div class="el-input">
                  <input type="text" autocomplete="off" maxlength="40" :placeholder="$t('license.form.name.placeholder')" class="el-input__inner" @input="changeInput($event, 'name')" @blur="validInput('name')"/>
                </div>
              </div>
            </div>
            <div ref="country" class="el-form-item is-required" :class="required.country ? 'is-success' : 'is-error'">
              <label for="country" class="el-form-item__label">{{$t('license.form.country.label')}}</label>
              <div v-show="!required.country" class="el-form-item__error">{{ this.$t('license.form.country.required')[0] }}</div>
              <div class="el-form-item__content">
                <el-select v-model="formData.country" :placeholder="$t('license.form.country.placeholder')" @change="changeCountry">
                  <el-option :label="item.countryNameEnglish" :value="item.countryName" v-for="item in country" :key="item.countryName"></el-option>
                </el-select>
              </div>
            </div>
            <div class="form-item">
              <div ref="address" v-if="language == 'en'" class="el-form-item is-required" :class="required.address ? 'is-success' : 'is-error'">
                <label for="address" class="el-form-item__label">{{$t('license.form.address.label')}}</label>
                <div v-show="!required.address" class="el-form-item__error">{{ this.$t('license.form.address.required')[0] }}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <input type="text" autocomplete="off" maxlength="100" :placeholder="$t('license.form.address.placeholder')" class="el-input__inner" @input="changeInput($event, 'address')" @blur="validInput('address')"/>
                  </div>
                </div>
              </div>
              <div ref="province" v-else class="flex">
                <div class="el-form-item is-required m-r-10 flex_1">
                  <label for="province" class="el-form-item__label">{{$t('license.form.address.label')}}</label>
                  <div v-show="!required.province" class="el-form-item__error">{{ this.$t('license.form.province.required')[0] }}</div>
                  <div v-show="required.province && !required.city" class="el-form-item__error">{{ this.$t('license.form.city.required')[0] }}</div>
                  <div class="el-form-item__content">
                    <el-select v-model="formData.province" :placeholder="$t('license.form.province.placeholder')" @change="changeAddress">
                      <el-option :label="item.name" :value="item.name" v-for="item in address" :key="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="el-form-item is-required flex_1 m-l-10 no-star" :class="required.city ? 'is-success' : 'is-error'">
                  <label for="city" class="el-form-item__label">{{$t('license.form.city.label')}}</label>
                  <div class="el-form-item__content">
                    <el-select v-model="formData.city" :placeholder="$t('license.form.city.placeholder')" @change="handleChange('city')">
                      <el-option :label="item.name" :value="item.name" v-for="item in (address.findIndex(($item) => $item.name == formData.province) != -1 ? address.filter(($item) => $item.name == formData.province)[0].cities : [])" :key="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div ref="email" class="el-form-item is-required" :class="required.email ? 'is-success' : 'is-error'">
              <label class="el-form-item__label">{{ $t('license.form.email.label') }}</label>
              <div v-show="!required.email" class="el-form-item__error">{{ this.$t('license.form.email.required')[formData.email == '' ? 0 : 1] }}</div>
              <div class="el-form-item__content">
                <div class="el-input">
                  <input type="text" autocomplete="off" maxlength="60" :placeholder="$t('license.form.email.placeholder')" class="el-input__inner" @input="changeInput($event, 'email')" @blur="validInput('email')"/>
                </div>
              </div>
            </div>
            <div v-if="language == 'en' && formData.topic == 'REGISTER'" class="p-b-10">
              <!-- <div ref="invitationCode" class="el-form-item is-required" :class="required.invitationCode ? 'is-success' : 'is-error'"> -->
              <div ref="invitationCode" class="el-form-item is-required" :class="{'is-success': required.invitationCode, 'is-error': !required.invitationCode, 'form-show': formData.topic == 'REGISTER', 'form-hide': formData.topic != 'REGISTER'}">
                <label class="el-form-item__label">{{$t('license.form.invitationCode.label')}}</label>
                <div v-show="!required.invitationCode" class="el-form-item__error">{{ this.$t('license.form.invitationCode.required')[formData.invitationCode == '' ? 0 : 1] }}</div>
                <div class="el-form-item__content">
                  <div class="el-input">
                    <input type="text" autocomplete="off" maxlength="10" :placeholder="$t('license.form.invitationCode.placeholder')" class="el-input__inner" @input="changeInput($event, 'invitationCode')" @blur="blurInvitationCode"/>
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="license-item m-t-10">
          <div class="license-item-title"><span class="ilblk p-r-16">{{$t('license.product.title')}}</span> <span v-if="formData.topic == 'REGISTER'" class="ilblk p-r-15 fontn fz-26" style="color: #cccccc;">{{ $t('license.product.warn') }}</span> <span v-if="productErr" class="ilblk error">{{ $t('license.product.error') }}</span></div>
          <div ref="product" class="license-product">
            <div class="license-product-title" :class="language == 'en' ? 'p-l-110' : ''" :style="{'background-image': `url(${$t('license.product.skull.bjImg')})`}">{{ $t('license.product.skull.title') }}</div>
            <div class="license-product-box flex flex_wrap">
              <div class="license-product-item flex align_items_center" :class="{active: formData.product == item.type, disabled: formData.topic == 'REGISTER', en: language == 'en'}" v-for="item, index in $t('license.product.skull.list')" :key="index">
                <div class="item-box" @click="getProjectName(item.type)">
                  <div>
                    <img :src="item.img" alt="" srcset="" class="m-b-15">
                    <p v-for="$item, $index in item.name" :key="$index">{{ $item }}</p>
                    <!-- <p>{{ item.name.join(' ') }}</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="license-product">
            <div class="license-product-title" :class="language == 'en' ? 'p-l-110' : ''" :style="{'background-image': `url(${$t('license.product.heart.bjImg')})`}">{{ $t('license.product.heart.title') }}</div>
            <div class="license-product-box flex flex_wrap">
              <div class="license-product-item flex align_items_center" :class="{active: formData.product == item.type, disabled: formData.topic == 'REGISTER', en: language == 'en'}" v-for="item, index in $t('license.product.heart.list')" :key="index">
                <div class="item-box" @click="getProjectName(item.type)">
                  <div>
                    <img :src="item.img" alt="" srcset="" class="m-b-15">
                    <p v-for="$item, $index in item.name" :key="$index">{{ $item }}</p>
                    <!-- <p>{{ item.name.join(' ') }}</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="license-item p-b-40 p-t-10">
          <div class="license-item-title p-b-25">{{$t('license.textarea.title')}}</div>
          <div class="el-textarea">
            <textarea autocomplete="off" :placeholder="$t('license.textarea.placeholder')" class="el-textarea__inner" style="min-height: 174px; height: 174px;" @input="changeInput($event, 'notes')" maxlength="300"></textarea>
          </div>
        </div>
        <div>
          <div class="license-policy flex justify_content_center">
            <el-checkbox v-if="language != 'en'" v-model="privacyStatus" @change="changePrivacy"></el-checkbox>
            <div class="posrel">
              <div v-show="!privacyStatus && formStatus" class="policy-tooltip">{{ $t('license.checked.tooltip') }}</div>
              <p class="p-l-19">{{ $t('license.checked.text').join() }}<span class="license-policy-hover" @click="dialogVisible = true">{{ $t('license.checked.sign') }}</span></p>
            </div>
          </div>
          <div class="textc">
            <el-button class="license-btn" :disabled="!submitStatus"  :loading="!submitStatus" @click="handleSubmit('licenseForm')">{{ !submitStatus ? $t('license.submiting') : $t('license.submit') }}</el-button>
          </div>
        </div>
      </div>
      <div v-else class="license-main-box results flex flex_col align_items_center justify_content_center">
        <div><img :src="require(`@/assets/images/license/${results.status}.png`)" alt="" srcset=""></div>
        <div>
          <p v-for="item, index in $t(`license.results.${results.status}`)" :key="index">{{ item }}</p>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      custom-class="license-dialog"
      width="90%">
      <div class="license-dialog-content">
        <div class="p-b-20" v-for="item, index in $t('license.policy.list')" :key="index">
          <p v-for="$item, $index in item" :key="$index" v-html="$item"></p>
        </div>
      </div>
      <div class="license-dialog-time">{{ $t('license.policy.date') }}</div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      formData: {
        topic: 'TRIAL', // 主题
        serialNumber: '', // 序列号
        institution: '', // 机构名称
        profession: '', // 职业
        surname: '', // 姓
        name: '', // 名
        country: '', // 国家
        province: '', // 省
        city: '', // 市
        address: '', // 地址---英文版
        areaCode: '', // 区号
        telephone: '', // 手机号码
        email: '', // 邮箱
        invitationCode: '', // 邀请码
        product: '',
        notes: '' // 备注
      },
      privacyStatus: false, // 隐私政策
      topic: [ // 主题
        { label: this.$t('license.formData.topic.probation'), value: 'TRIAL' },
        { label: this.$t('license.formData.topic.code'), value: 'REGISTER' }
      ],
      profession: [
        { label: this.$t('license.formData.profession.physician.name'), value: this.$t('license.formData.profession.physician.value') },
        { label: this.$t('license.formData.profession.technician.name'), value: this.$t('license.formData.profession.technician.value') },
        { label: this.$t('license.formData.profession.scientificResearch.name'), value: this.$t('license.formData.profession.scientificResearch.value') },
        { label: this.$t('license.formData.profession.other.name'), value: this.$t('license.formData.profession.other.value') }
      ],
      country: [],
      address: [
        // { name: '北京市', value: 'bj', cities: [{ name: '北京市', value: 'bj' }] },
        // { name: '浙江省', value: 'zj', cities: [{ name: '杭州市', vlaue: 'hz' }, { name: '舟山市', value: 'zs' }, { name: '金华市', value: 'jh' }] }
      ],
      areaCode: [
        { label: '+86', value: '86' }
      ],
      required: {
        serialNumber: true, // 序列号
        institution: true, // 机构名称
        profession: true, // 职业
        surname: true, // 姓
        name: true, // 名
        country: true, // 国家
        province: true, // 省
        city: true, // 市
        address: true, // 地址---英文版
        email: true, // 邮箱
        invitationCode: true, // 邀请码
        product: true
      },
      rules: {
        topic: [
          { required: true, message: this.$t('license.form.topic.required')[0], trigger: 'change' }
        ],
        profession: [
          { required: true, message: this.$t('license.form.profession.required')[0], trigger: 'change' }
        ],
        country: [
          { required: true, message: this.$t('license.form.country.required')[0], trigger: 'change' }
        ],
        province: [
          { required: true, message: this.$t('license.form.province.required')[0], trigger: 'change' }
        ],
        city: [
          { required: true, message: this.$t('license.form.city.required')[0], trigger: 'change' }
        ],
        areaCode: [
          { required: true, message: this.$t('license.form.areaCode.required')[0], trigger: 'change' }
        ]
      },
      formStatus: false, // 表单验证状态
      submitStatus: true, // 表单提交按钮状态
      dialogVisible: false,
      productErr: false,
      invitationCodeStatus: true,
      results: { // 提交状态
        visible: false,
        status: 'succ'
      }
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  created () {
    this.getAddress()
    this.formData.serialNumber = this.$route.query.serial ? this.$route.query.serial : ''
    if (this.formData.serialNumber !== '') {
      this.formData.topic = 'REGISTER'
      this.getSerialNumber()
    }
  },
  mounted () {
    if (this.$refs.serialNumber) {
      this.$refs.serialNumber.value = this.formData.serialNumber
    }
  },
  methods: {
    // 输入框事件
    changeInput (evt, name) {
      this.formData[name] = evt.target.value
      // if (name === 'serialNumber') {
      //   this.required.serialNumber = true
      // }
      this.required[name] = true
    },
    // 验证输入框事件
    validInput (name) {
      if (this.formData[name] === '') {
        this.required[name] = false
      } else {
        if (name === 'telephone') {
          if (this.language === 'en') {
            this.required[name] = /^[0-9]{1,20}$/.test(this.formData[name])
          } else {
            this.required[name] = /^1[3456789]\d{9}$/.test(this.formData[name])
          }
        } else if (name === 'email') {
          this.required[name] = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.formData[name])
        } else if (name === 'invitationCode') {
          this.required[name] = this.invitationCodeStatus
        } else if (name === 'serialNumber') {
          this.required[name] = this.formData.product !== ''
        } else {
          this.required[name] = true
        }
      }
    },
    handleChange (name) {
      this.required[name] = true
    },
    // 通过序列号设置产品
    getSerialNumber () {
      // this.formData.serialNumber = 'C07006300E4JRH1AR2024031114140101C07C90JTPJH8'
      const parms = {
        serialNumber: this.formData.serialNumber
      }
      console.log(parms)
      if (/[^a-zA-Z0-9]/.test(parms.serialNumber)) {
        this.formData.product = ''
        this.required.serialNumber = false
      } else {
        this.$store.dispatch('app/getModelBySerialNumber', parms).then((res) => {
          console.log(res)
          if (res) {
            this.formData.product = res
          } else {
            this.formData.product = ''
          }
          this.validInput('serialNumber')
        }).catch((err) => {
          console.log(err)
          // this.validInput('serialNumber')
          this.formData.product = ''
          this.required.serialNumber = false
        })
      }
    },
    // 获取地址信息
    getAddress () {
      if (this.language === 'en') {
        this.country = []
        this.$store.dispatch('app/getAllCountries', {}).then((res) => {
          console.log(res)
          this.country = res.filter(item => item.countryName !== '中国')
          this.formData.country = this.country[0].countryName
          this.formData.areaCode = this.country[0].areaCode
          const uniqueArr = this.country.filter((item, index, self) => {
            return (
              index === self.findIndex((t) => {
                return t.areaCode === item.areaCode
              })
            )
          })
          const areaCode = uniqueArr.map(item => {
            return { label: '+' + item.areaCode, value: item.areaCode }
          })
          this.areaCode = areaCode
          this.required.country = true
        }).catch((err) => {
          console.log(err)
        })
      } else {
        this.country = [{ countryName: '中国', areaCode: '86', countryNameEnglish: '中国' }]
        this.formData.country = '中国'
        this.required.country = true
        this.formData.areaCode = this.country[0].areaCode
        this.$store.dispatch('app/getAllArea', {}).then((res) => {
          console.log(res)
          this.address = res
        }).catch(() => {
        })
      }
    },
    // 提交数据
    handleSubmit (formName) {
      this.submitStatus = false
      if (this.formData.topic === 'TRIAL' && this.formData.product === '') {
        this.productErr = true
      } else {
        this.productErr = false
      }
      for (const key in this.required) {
        this.validInput(key)
        if (this.formData.topic === 'TRIAL') { // 申请试用
          this.required.serialNumber = true
          this.required.invitationCode = true
        }
        if (this.language === 'en') {
          this.required.province = true
          this.required.city = true
        } else {
          this.required.address = true
          this.required.invitationCode = true
        }
      }
      console.log(this.required)
      this.$refs[formName].validate((valid, object) => {
        for (const key in this.required) {
          if (!this.required[key]) {
            console.log(key)
            const { top } = this.$refs[key === 'city' ? 'province' : key] && this.$refs[key === 'city' ? 'province' : key].getBoundingClientRect()
            if (top) {
              this.backTop(top)
            }
            this.submitStatus = true
            return
          }
        }
        if (valid) {
          this.submitStatus = false
          console.log(this.formData)
          if (this.formData.product !== '') {
            console.log('表单验证成功！')
            this.formStatus = true
            if (this.language === 'en') {
              this.privacyStatus = true
            }
            if (this.privacyStatus) {
              console.log('隐私政策已勾选')
              const parms = {
                purpose: this.formData.topic, // 主题
                serialNumb: this.formData.serialNumber,
                hospital: this.formData.institution,
                career: this.formData.profession, // 职业
                firstName: this.formData.surname,
                lastName: this.formData.name,
                country: this.formData.country,
                province: this.formData.province,
                area: this.formData.city,
                address: this.formData.address,
                // phoneNumb: this.formData.telephone,
                email: this.formData.email,
                productType: this.formData.product, // 产品
                notes: this.formData.notes,
                invitationCode: this.formData.invitationCode, // 邀请码
                hardwareInformation: navigator.userAgent,
                areaCode: this.formData.areaCode
              }
              console.log(parms)
              this.$store.dispatch('app/submitInfo', parms).then((res) => {
                console.log(res)
                this.results = {
                  visible: true,
                  status: res != null ? 'warn' : 'succ'
                }
                window.scrollTo(0, 200)
              }).catch((err) => {
                console.log(err)
                this.submitStatus = true
                this.results = {
                  visible: true,
                  status: 'err'
                }
                window.scrollTo(0, 200)
              })
            } else {
              this.submitStatus = true
            }
          } else {
            console.log('表单验证成功，产品未选择')
            this.formStatus = false
            this.submitStatus = true
          }
        } else {
          console.log(valid, object)
          this.formStatus = false
          this.submitStatus = true
          console.log('error submit!!')
          return false
        }
      })
    },
    // 主题选择
    changeTopic (name) {
      console.log(name)
      this.formData.product = ''
      this.required.serialNumber = true
      if (name === 'REGISTER') {
        if (this.formData.serialNumber !== '') {
          this.getSerialNumber()
        } else {
        }
      } else {
      }
    },
    changeContact (name) {
      if (this.formData[name] !== '') {
        this.validInput(name)
      }
    },
    getProjectName (name) {
      console.log(name)
      if (this.formData.topic !== 'REGISTER') {
        this.productErr = false
        this.formData.product = name
      }
    },
    // 序列号失去焦点
    blurSerialNumber () {
      this.getSerialNumber()
    },
    changePrivacy (val) {
      this.privacyStatus = val
      // this.dialogVisible = val
    },
    // 选择省时间
    changeAddress () {
      this.formData.city = ''
      this.required.province = true
    },
    // 选择国家
    changeCountry (val) {
      this.required.country = true
      this.formData.areaCode = this.country.filter(item => item.countryName === val)[0].areaCode
    },
    // 邀请码失去焦点
    blurInvitationCode () {
      const parms = {
        invitationCode: this.formData.invitationCode
      }
      this.$store.dispatch('app/checkInvitationCode', parms).then((res) => {
        console.log(res)
        this.invitationCodeStatus = true
        this.validInput('invitationCode')
      }).catch((err) => {
        console.log(err)
        this.invitationCodeStatus = false
        this.validInput('invitationCode')
      })
    },
    // 返回顶部
    backTop (top) {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      const clientTop = scrollTop + top
      let timer = setInterval(() => {
        scrollTop -= 60
        if (scrollTop <= clientTop - 100) {
          window.scrollTo(0, 0)
          clearInterval(timer)
          timer = null
        }
        window.scrollTo(0, scrollTop)
      }, 50)
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/common.less";
.m .license-research {
  .license-bj {
    position: relative;
    img{
      // margin-bottom: -3PX;
    }
    .science-bj-txt {
      position: absolute;
      right: 30px;
      bottom: 80px;
    }
  }
  // }
  .license-content {
    margin: 0 30px;
    position: relative;
    padding-bottom: 0;
    top: -50px;
  }
  .license-main-title {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 8px 0px 5px -5px rgba(81,170,255,0.1), -8px 0px 5px -5px rgba(81,170,255,0.1), 0 -8px 0px 0px rgba(81,170,255,0.1);
    border-top-left-radius: 13px;
    border-top-right-radius: 13px;
    z-index: 2;
    font-size: 24px;
    padding: 40px 34px;
    border-bottom: 1px solid rgba(151, 151, 151, 0.2);
    .license-main-title-box {
      margin: 0 auto;
      line-height: 40px;
      padding-left: 60px;
      position: relative;
      display: inline-block;
      &::before {
        content: '';
        display: block;
        width: 33px;
        height: 100%;
        position: absolute;
        left: 0;
        background-image: url(~@/assets/images/license/prompt.png);
        background-repeat: no-repeat;
        background-size: 33px 33px;
        background-position: left 10px;
      }
    }
  }
  .license-main-box {
    margin: 0 auto;
    min-height: 426px;
    padding: 20px 34px;
    background: #FFFFFF;
    box-shadow: 0px 6px 10px 4px rgba(81,170,255,0.07);
    border-bottom-left-radius: 13px;
    border-bottom-right-radius: 13px;
    position: relative;
    &.results {
      text-align: center;
      line-height: 40px;
      padding-bottom: 100px;
      font-size: 26px;
      img {
        margin-bottom: 30px;
      }
    }
  }
  .license-item-title {
    color: #333333;
    font-size: 28px;
    font-weight: 600;
    line-height: 40px;
    .error {
      // font-size: 20px;
      font-size: 24px;
      color: #FA2626;
      font-weight: normal;
    }
  }
  .license-product {
    padding: 20px 0;
    text-align: center;
    .license-product-title {
      display: inline-block;
      line-height: 70px;
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center;
      padding-left: 80px;
      padding-right: 50px;
      font-size: 30px;
      margin-bottom: 24px;
      white-space: nowrap;
    }
    .license-product-box {
      background: #FBFBFB;
      border-radius: 7px;
      padding-top: 30px;
      // padding-bottom: 18px;
    }
    .license-product-item {
      width: 50%;
      // height: 280px;
      text-align: center;
      font-size: 26px;
      line-height: 38px;
      cursor: pointer;
      position: relative;
      // padding-top: 14px;
      margin-bottom: 30px;
      .item-box {
        border-radius: 8px;
        position: relative;
        border: 2px solid;
        border-color: transparent;
        margin: 0 auto;
        padding-top: 44px;
        padding-bottom: 20px;
        max-width: 80%;
        min-width: 280px;
        height: 100%;
        &::before,
        &::after {
          content: "";
          width: 0;
          height: 2PX;
          position: absolute;
          transition: all .2s linear;
        }
        &::before {
          background: rgba(240, 7, 7, 1);
        }
        &::after {
          background: rgba(3, 125, 220, 1);
        }
        img {
          width: 114px;
        }

        & > div::before,
        & > div::after {
          content: "";
          width: 2PX;
          height: 0;
          position: absolute;
          transition: all .2s linear;
          background: linear-gradient(180deg, rgba(240, 7, 7, 1), rgba(3, 125, 220, 1));
        }
        &::after {
          left: -2PX;
          bottom: -2PX;
          transition-duration: .4s;
        }
        & > div::after {
          right: -2PX;
          top: -2PX;
          transition-duration: .4s;
        }
        &::before {
          right: -2PX;
          top: -2PX;
          transition-duration: .4s;
        }
        & > div::before {
          left: -2PX;
          bottom: -2PX;
          transition-duration: .4s;
        }
      }
      &.en {
        height: 270px;
        margin-bottom: 0;
      }
      &.disabled {
        cursor: inherit;
        opacity: 0.5;
      }
      &.active .item-box {
        background: rgba(29,106,249,0.07);
        border-image: linear-gradient(180deg, rgba(240, 7, 7, 1), rgba(3, 125, 220, 1)) 2 2;
        &::before, &::after {
          width: calc(100% + 4PX);
        }
        & > div::before, & > div::after {
          height: calc(100% + 4PX);
        }
      }
    }
  }
  .license-policy {
    font-size: 22px;
    line-height: 30px;
    .license-policy-hover {
      color: #008DE2;
      cursor: pointer;
    }
    .policy-tooltip {
      background: #6b6b6d;
      color: #FFF;
      height: 40px;
      padding: 5px 15px;
      position: absolute;
      font-size: 22px;
      border-radius: 10px;
      top: -50px;
      left: 19px;
      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 40px;
        left: 19px;
        width: 0;
        height: 0;
        border-top: 6PX solid #6b6b6d;
        border-right: 6PX solid transparent;
        border-left: 6PX solid transparent;
        border-bottom: 6PX solid transparent;
      }
    }
  }
  .license-btn {
    width: 456px;
    min-width: 100%;
    height: 70px;
    background-image: url("~@/assets/images/guidance/btn.png");
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 100%;
    color: #ffffff;
    background-color: #0086C0;
    box-shadow: 0PX 2PX 4PX 0PX rgba(0,146,225,0.34);
    border-radius: 13px;
    font-size: 26px;
    text-align: center;
    padding: 10px;
    line-height: 50px;
    cursor: pointer;
    margin: 35px 0;
    &.disabled {
      background: #ffffff;
      border: 1px solid #ebeef5;
      color: #c0c4cc;
      box-shadow: none;
      cursor: not-allowed;
    }
  }
  .license-dialog {
    .license-dialog-content {
      height: calc(100% - 40px);
      overflow: auto;
      color: #333333;
      word-break: initial;
    }
    .license-dialog-time {
      color: #8B8B8B;
      padding-top: 20px;
    }
  }
}
.m.en .license-research {
  .license-bj {
    .license-bj-txt {
      left: 4%;
    }
    .license-bj-title {
      font-size: 40PX;
      // line-height: 98PX;
    }
  }
}
</style>

<style lang="less">
@import "~@/styles/common.less";
.m .license-research {
  .license-form {
    .el-input__inner {
      height: 72px;
      line-height: 72px;
      padding-left: 34px;
      border-radius: 10px;
      border-color: #D3D3D3;
    }
    .el-input__inner, .el-input__inner::placeholder {
      font-size: 24px;
    }
    .el-input__inner::placeholder {
      color: #cccccc;
    }
    .el-form-item {
      margin-bottom: 34px;
      transition: max-height 0.3s;
      overflow: hidden;
      &.form-show {
        max-height: 140px;
      }
      &.form-hide {
        max-height: 0;
        margin-bottom: 0;
      }
    }
    .el-form-item__label {
      font-size: 24px;
      line-height: 34px;
      padding-bottom: 22px;
      color: #333333;
      float: left;
    }
    .el-form-item__content {
      .el-select {
        width: 100%;
        .el-input__inner {
          -webkit-user-select: none;
          -moz-user-select: none;
          -webkit-user-select:none;
          -o-user-select:none;
          user-select:none;
        }
      }
    }
    .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
      display: none;
    }
    .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after {
      content: "*";
      color: #FF1717;
      margin-left: 4px;
    }
    .el-form-item.no-star.is-required:not(.is-no-asterisk)>.el-form-item__label:after{
      content: " ";
    }
    .el-radio__label {
      font-size: 18px;
      line-height: 26px;
    }
    .el-radio__inner {
      top: -1PX;
    }
    .el-form-item__error {
      color: #FA2626;
      position: initial;
      margin-left: 15px;
      display: inline-block;
      font-size: 24px;
      line-height: 34px;
      padding-top: 0;
    }
  }
  .el-textarea {
    font-size: 26px;
    .el-textarea__inner {
      border-radius: 10px;
      padding: 20px 23px;
      line-height: 40px;
    }
    .el-textarea__inner::placeholder {
      font-size: 26px;
      color: #cccccc;
      line-height: 40px;
    }
  }
  .license-policy {
    .el-checkbox__input {
      // margin-bottom: 6PX;
      &.is-focus:not(.is-checked) .el-checkbox__inner {
        border-color: #DCDFE6;
        background-color: #ffffff;
      }
    }
    .el-checkbox__inner {
      width: 25px;
      height: 25px;
      &::after {
        width: 6px;
        height: 9px;
        left: 6px;
      }
    }
  }
  .license-dialog {
    height: 80vh;
    margin-top: 0 !important;
    &:extend(.center_up_down_left_right);
    border-radius: 38px;
    .el-dialog__header {
      padding: 20px;
    }
    .el-dialog__headerbtn {
      border-width: 0;
      font-size: 36px;
      top: 15px;
      right: 10px;
    }
    .el-dialog__body {
      padding: 30px 36px;
      font-size: 26px;
      line-height: 34px;
      overflow: auto;
      height: 100%;
    }
  }
}
</style>
